<div class="main">
    <div class="progressBar">
        <app-progress-bar-register [atRegisterForm]="atRegisterForm"></app-progress-bar-register>
    </div>
    <div class="payment">
        <div style="margin: 0;">
            <app-left-payment-panel (paymentGatewayRes)="paymentGatewayRes($event)"></app-left-payment-panel>
        </div>

        <div class="" style="width: 60%;">
            <app-reg-common-form [inputDataList]="inputDataList" [heading]="formHeading"
                (formButtonResEvent)="formButtonResEvent($event)" [submitBtnText]="submitBtnText" showDraftBtn='true'
                [DraftBtnText]="draftBtnText">
            </app-reg-common-form>
        </div>

        <div class="rightPanel">
            <app-profile-progress></app-profile-progress>
            <app-payment-summary></app-payment-summary>
        </div>
    </div>
</div>